
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industrial-alcohol-disposal",
      function () {
        return require("private-next-pages/industrial-alcohol-disposal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industrial-alcohol-disposal"])
      });
    }
  